import { QUESTION_TYPE } from 'app/question/question-type.const';
import { SimpleQuestionMapper, ComplexQuestionMapper } from 'app/question';

export class QuestionAdapter {
  public static map(questionData: any): any {
    if (!questionData) {
      return null;
    }

    if (
      QUESTION_TYPE.MATRIX === questionData.type ||
      QUESTION_TYPE.SLIDER === questionData.type
    ) {
        return ComplexQuestionMapper.map(questionData);
    }

    if (
        QUESTION_TYPE.CLOSE_SINGLE ||
        QUESTION_TYPE.OPEN ||
        QUESTION_TYPE.CLOSE_MULTICHOICE === questionData.type
    ) {
        return SimpleQuestionMapper.map(questionData);
    }
  }
}



// WEBPACK FOOTER //
// /dist/src/app/question/question.adapter.ts